import React from "react";
import "./GridStyles.css";

function GridData(props) {
  const handleClick = (event) => {
    event.preventDefault(); // prevent the default link behavior
    window.open(props.url, "_blank"); // open the URL in a new tab
  };

  return (
    <a
      href={props.url}
      onClick={handleClick}
      target="_blank"
      rel="noreferrer"
      className="itemCard"
    >
      <div className="ic-image">
        <img alt="img" src={props.image} />
      </div>
      <h4>{props.heading}</h4>
      <p>{props.text}</p>
    </a>
  );
}

export default GridData;
